/* ============================================================================
   JUST START — Shopify commerce layer
   Variant picker + AJAX add-to-cart + cart count. Vanilla, no deps.
   Falls back gracefully to native form POST if JS fails.
   ============================================================================ */
(function () {
  "use strict";
  var routes = (window.JUSTSTART && window.JUSTSTART.routes) || {};

  function money(cents, currency) {
    var format = window.JUSTSTART && window.JUSTSTART.moneyFormat;
    if (format) {
      var amount = Number(cents || 0) / 100;
      var token = (format.match(/\{\{\s*(amount(?:_[a-z_]+)?)\s*\}\}/) || [])[1];
      if (token) {
        var decimals = token === "amount_no_decimals" ? 0 : 2;
        var decimalMark = token === "amount_with_comma_separator" ? "," : ".";
        var thousandsMark = token === "amount_with_comma_separator" ? "." : token === "amount_with_apostrophe_separator" ? "'" : ",";
        var parts = amount.toFixed(decimals).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
        return format.replace(/\{\{\s*amount(?:_[a-z_]+)?\s*\}\}/, parts[0] + (decimals ? decimalMark + parts[1] : ""));
      }
    }
    try {
      var locale = document.documentElement.lang || "ar-SA";
      return new Intl.NumberFormat(locale, { style: "currency", currency: currency || "SAR" }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  /* One money formatter for the theme. The favourites drawer renders live
     prices too, and a second copy of this rounding and separator logic would
     eventually disagree with this one on some currency. */
  window.JUSTSTART = window.JUSTSTART || {};
  window.JUSTSTART.money = money;

  function announceCommerce(message, isError) {
    var toast = document.querySelector("[data-jst-commerce-toast]");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "jst-commerce-toast";
      toast.setAttribute("data-jst-commerce-toast", "");
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      toast.setAttribute("aria-atomic", "true");
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.toggle("is-error", Boolean(isError));
    toast.classList.add("is-visible");
    window.clearTimeout(announceCommerce.timer);
    announceCommerce.timer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 2600);
  }

  /* ---------- Cart count refresh ---------- */
  function refreshCartCount() {
    fetch(routes.cart || "/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------- Variant picker (product page) ---------- */
  (function () {
    var root = document.querySelector("[data-jst-product]");
    if (!root) return;
    var dataEl = root.parentNode.querySelector("[data-product-variants]") || document.querySelector("[data-product-variants]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var select = root.querySelector("[data-variant-select]");
    var priceBox = root.querySelector("[data-price]");
    var addBtn = root.querySelector("[data-add-btn]");
    var addLabel = root.querySelector("[data-add-label]");
    var bnplAmount = root.querySelector("[data-bnpl-amount]");
    var currency = root.getAttribute("data-shop-currency") || "SAR";
    var optionInputs = root.querySelectorAll("[data-option-selector]");
    // «قريبًا»: نصّه من الخادم، ويظهر للخيار غير المتوفر اللي ما له سعر بعد
    var soonEl = priceBox && priceBox.querySelector(".jst-coming-soon");
    var soonText = soonEl ? soonEl.textContent.trim() : "";

    function currentOptions() {
      var opts = [];
      root.querySelectorAll(".jst-product__option").forEach(function (fs) {
        var checked = fs.querySelector("input:checked");
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function update() {
      var opts = currentOptions();
      var v = findVariant(opts);
      root.querySelectorAll(".jst-product__swatch").forEach(function (s) {
        var input = s.querySelector("input");
        s.classList.toggle("is-active", input && input.checked);
      });
      if (!v) return;
      if (select) select.value = v.id;
      var comingSoon = soonText && !v.available && !v.price;
      if (priceBox) {
        var html = "";
        if (comingSoon) {
          html = '<span class="jst-product__price-now jst-coming-soon">' + soonText + '</span>';
        } else if (v.compare_at_price && v.compare_at_price > v.price) {
          html = '<s class="jst-price-before-discount">' + money(v.compare_at_price, currency) + '</s> <span class="jst-product__price-now">' + money(v.price, currency) + '</span> <span class="jst-card__badge">' + (((window.JUSTSTART || {}).i18n || {}).onSale || "Sale") + '</span>';
        } else {
          html = '<span class="jst-product__price-now">' + money(v.price, currency) + '</span>';
        }
        priceBox.innerHTML = html;
      }
      if (bnplAmount) bnplAmount.textContent = money(v.price / 4, currency);
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel && comingSoon) addLabel.textContent = soonText;
      else if (addLabel) addLabel.textContent = v.available ? ((window.JUSTSTART.i18n && window.JUSTSTART.i18n.add) || "Add to cart") : ((window.JUSTSTART.i18n && window.JUSTSTART.i18n.soldout) || "Sold out");
      try {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        window.history.replaceState({}, "", url);
      } catch (e) {}
    }

    optionInputs.forEach(function (input) {
      input.addEventListener("change", update);
    });
    update();
  })();

  /* ---------- AJAX add to cart (product form) ---------- */
  (function () {
    var form = document.getElementById("jst-product-form");
    if (!form) return;
    form.addEventListener("submit", function (e) {
      // Only intercept the "add" button, let checkout/payment buttons behave natively
      if (!e.submitter || e.submitter.name !== "add") return;
      e.preventDefault();
      var btn = form.querySelector("[data-add-btn]");
      if (btn) btn.classList.add("is-loading");
      var fd = new FormData(form);
      fetch(routes.cart_add || "/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: fd
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || "Cart request failed");
            return data;
          });
        })
        .then(function () {
          refreshCartCount();
          if (btn) { btn.classList.remove("is-loading"); btn.classList.add("is-added"); }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: "add_to_cart" });
          setTimeout(function () { if (btn) btn.classList.remove("is-added"); }, 1600);
        })
        .catch(function (error) {
          if (btn) btn.classList.remove("is-loading");
          var feedback = document.querySelector("[data-pdp-feedback]");
          if (feedback) feedback.textContent = error.message || (((window.JUSTSTART || {}).i18n || {}).cartError || "Unable to add this item.");
        });
    });
  })();

  /* ---------- Quick add (product cards) ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-jst-quick-add]");
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute("data-variant-id");
    if (!id) return;
    btn.classList.add("is-loading");
    fetch(routes.cart_add || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || "Cart request failed");
          return data;
        });
      })
      .then(function () {
        refreshCartCount();
        btn.classList.remove("is-loading");
        btn.classList.add("is-added");
        announceCommerce((((window.JUSTSTART || {}).i18n || {}).cartAdded || "Added to cart"), false);
        setTimeout(function () { btn.classList.remove("is-added"); }, 1400);
      })
      .catch(function () {
        btn.classList.remove("is-loading");
        announceCommerce((((window.JUSTSTART || {}).i18n || {}).cartError || "Unable to add this item."), true);
      });
  });

  /* The header count is server-rendered. Refresh only after a cart mutation. */
})();
